<template>

  <div class="home-page">
    <Header></Header>
    <section class="home-section-video">
      <!--padding:56.25% 0 0 0;-->
      <div style="padding:0 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/495826638?background=1&autoplay=1&loop=1&autopause=0&muted=1&controls=0&sidedock=0&title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div>
    </section>
    <section class="hero-section background-fit" :style="{ backgroundImage: `url(${backgroundUrl6})` }">
      <div class="container">
        <div class="row">
          <div class="col-md-12 hero-col">
            <div class="hero-blk">
              <h2 style="font-size: 36px;line-height: 46px;font-weight: 400;">Connecting Artists Globally</h2>
              <div class="hero-action-blk">
                <router-link class="view-s" v-if="!logedIn" to="/signup">Join the Community</router-link>
                <router-link class="view-s" v-if="logedIn" to="/campaign/5f0830801d84d464c6346ba8">Join a Stage</router-link>
                <!--<router-link class="join-c" to="/stages">VIEW STAGES</router-link>-->
                <!--<router-link class="join-c" to="/campaign/5f0830801d84d464c6346ba8">VIEW CAMPAIGNS</router-link>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="s-stage-section background-fit" :style="{ backgroundImage: `url(${backgroundUrl})` }">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="create-stage-blk">
              <h2>Connect. Collaborate. Create.</h2>
              <router-link class="view-s" to="/artists">VIEW ARTISTS</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="fc-section home-fc">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <h2>Featured Stages</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 fc-col" v-for="(stage) in featuredStages" v-bind:key="stage.id">
            <router-link :to="'/stage/' + stage._id + `/`" class="inner-blk background-fit" :style="{ backgroundImage: `url(${imageUrl + stage.videoId[0].videoImageFile})` }">
              <div class="i-blk">
                <div class="profile-p background-fit" :style="{ backgroundImage: `url(${imageUrl + stage.userId[0].profiles[0].images[0].profileImageFile})` }"></div>
                <div class="p-detail">
                  <h3>{{stage.title}}</h3>
                  <p>{{stage.created | formatDate}}</p>
                  <!--<router-link :to="'/stage/' + stage._id + `/`"><span><img src="@/assets/img/next-arrow-white.svg" width="40" /></span></router-link>-->
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <section class="s-stage-section background-fit pb-4" :style="{ backgroundImage: `url(${backgroundUrl9})` }">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="create-stage-blk">
              <router-link class="join-c" to="/stages">VIEW STAGES</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './Header'
import Footer from './Footer'
import axios from 'axios'
import $ from "jquery"
import backgroundUrl from '@/assets/img/homeB.jpg'
import backgroundUrl4 from '@/assets/img/image4.jpg'
import backgroundUrl5 from '@/assets/img/image5.svg'
import backgroundUrl6 from '@/assets/img/homevideobanner.jpg'
import backgroundUrl9 from '@/assets/img/image9.jpg'
export default {
  name: 'Home',
  components: {
    'Header': Header,
    'Footer': Footer
  },
  mounted () {
      let windowWidth = $(window).width()
      let windowHeight = windowWidth*0.5625
      if(windowWidth < 667){
          windowHeight = '100vh'
          windowWidth = '177vh'
          $('.home-page .hero-section').height($(window).height())
      }
      $('.home-section-video >div iframe').css({
          height: windowHeight,
          width: windowWidth
      })
      axios
          .get('/getFeaturedStages')
          .then(response => {
              this.featuredStages = response.data
          })
          .catch(error => console.log(error))
      var userdata = localStorage.getItem('cbs_usertoken')
      if(userdata){
          userdata = JSON.parse(userdata)
          this.logedIn = true
      }
  },
  data () {
    return {
        backgroundUrl: backgroundUrl,
        backgroundUrl4: backgroundUrl4,
        backgroundUrl5: backgroundUrl5,
        backgroundUrl6: backgroundUrl6,
        backgroundUrl9: backgroundUrl9,
        featuredStages: '',
        imageUrl: process.env.imageUrl,
        logedIn: false,
        msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue